/**
 * <s-studio-process> — Velle Studio "o fio que vira peça".
 * As each step card ([data-step-card="1".."6"]) reaches the middle of the screen, the host gets data-step="n" and
 * config/styles.css builds the t-shirt: sketch → fabric → seams → print → check/tag → into the bag.
 * Starts at data-step="0" so the sketch draws itself when the story comes into view.
 * Reduced motion: states still change, config/styles.css removes every transition and animation.
 */
class SStudioProcess extends HTMLElement {
  #observer;

  connectedCallback() {
    const cards = this.querySelectorAll('[data-step-card]');
    if (!cards.length) return;
    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const step = entry.target.dataset.stepCard;
        this.dataset.step = step;
        for (const card of cards) {
          if (card.dataset.stepCard === step) card.setAttribute('aria-current', 'step');
          else card.removeAttribute('aria-current');
        }
      }
    }, { rootMargin: '-45% 0px -45% 0px' });
    cards.forEach((card) => this.#observer.observe(card));
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

customElements.define('s-studio-process', SStudioProcess);
